<template>
      <div class="displayMode">
        <font-awesome-icon :icon="[ 'fas', 'th' ]" :class="{'active':displayMode === 'grid'}" v-on:click="changeDisplay('grid')" class="cursor-pointer"/>
        <font-awesome-icon :icon="[ 'fas', 'th-list' ]" :class="{'active':displayMode === 'list'}" v-on:click="changeDisplay('list')" class="cursor-pointer"/>
      </div>
</template>
<script>

export default {
  name: 'app',
  props: {
    displayMode: String
  },
  components: {},
  methods: {
    changeDisplay: function (newVal) {
      this.$emit('displaySelected', newVal)
    }
  }
}

</script>
